import Model from 'src/app/common/model';
import Vendors from './vendor.model';
import ItemMasterModel from './itemMaster.model';
import PaymentTransactionModel from './paymentTransaction.model';
import TransactionsModel from './transactions.model';
import FarmSiteModel from './farmSite.model';

export default class VendorDuesModel extends Model {
  PaymentTransaction: PaymentTransactionModel;
  invoiceItems: Array<invoiceItemDetails>;
  VendorPaymentTransactions: VendorPaymentTransactionId;
  itemMaster: Array<ItemMasterModel>;
  farmSite: Array<FarmSiteModel>;
  Transaction: TransactionsModel;
  vendor_id: number;
  Vendor: Vendors;
  item_id: number;
  business_id: string;
  farm_site_id: string;
  material_transaction_id: number;
  payment_transaction_id: number;
  purchase_amount: number;
  return_amount: number;
  unpaid_amount: number;
  paid_amount: number;
  as_of_date: string;
  filePath: string;
  order?: string;
  orderWithUpdatedAt?: string;
  pageSize?: number;
  businessName: string;
  farmNameAtLocation: string;

  constructor() {
    super();
  }
}

//////////////////////////////
//VendorPaymentTransactionId
//////////////////////////////
export class VendorPaymentTransactionId {
  id: number;

  constructor() { }
}

//////////////////////////////
//invoiceItemDetails
//////////////////////////////
export class invoiceItemDetails {
  Items: Array<Items>;
  Invoice: number;
  sub_type: string;
  constructor() { }
}

//////////////////////////////
//Items
//////////////////////////////
export class Items {
  ItemName: string;
  quantity: number;
  uom: string;

  constructor() { }
}

